<template>
  <section id="powerOfAttorney" data-test-component="powerOfAttorney" v-cloak v-if="model">
    <div class="container">
      <div class="row">
        <div class="small-12 columns">
          <h1 v-html="model.Content.ReceivedMyPOAs" />
        </div>
      </div>

      <div class="row large-unstack">
        <div class="columns">
          <h2 v-html="model.Content.ReceivedYouveReceivedPOAFrom" />
          <div v-if="Object.keys(vueModel.PowersOfAttorneyReceivedFrom).length > 0">
            <div v-for="giver in vueModel.PowersOfAttorneyReceivedFrom" class="row push-down">
              <div class="small-12 medium-6 columns">
                {{ giver.FirstName }} {{ giver.LastName }}
                <div class="margin-on-small-10 text-faded">
                  ({{ giver.AccessType }})
                </div>
              </div>
              <div class="small-12 medium-6 columns">
                <button
                  class="button secondary"
                  @click="switchToMember(giver, model.Content.SelfServiceUrl)"
                  :disabled="
                    !vueModel.CanUsePowerOfAttorneyFunctionality ||
                      !giver.IsImpersonationAllowed ||
                      pending
                  "
                >
                  {{ model.Content.ReceivedShiftToThisMember }}
                  <div class="spinner spinner-button" v-show="giver.pendingGiver" />
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <p v-html="model.Content.ReceivedYouveNotReceivedPOAFrom" />
          </div>
          <p v-html="model.Content.ReceivedPOAReceivedDisclaimer" />
        </div>
        <div class="columns block--right" v-if="model.Content.UserCanSeeAddPowerOfAttorneySection">
          <h2>{{ model.Content.GivenYouveGrantedPOATo }}</h2>
          <div v-if="Object.keys(vueModel.PowersOfAttorneyGivenTo).length > 0">
            <div v-for="holder in vueModel.PowersOfAttorneyGivenTo" class="row push-down">
              <div class="small-12 columns">
                {{ holder.FirstName }} {{ holder.LastName }}
                <div>
                  <button
                    @click="redirectToEditPage(holder.ContactId)"
                    class="editable"
                    :disabled="!vueModel.CanUsePowerOfAttorneyFunctionality"
                    data-clickcategory="minside"
                    data-clickaction="click-fs mine fuldmagter"
                    data-clicklabel="fjern fuldmagt"
                  >
                    <span class="color-gray"> ({{ holder.AccessType }}) </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p v-html="model.Content.GivenYouveNotGrantedPOATo" />
          </div>
          <p v-html="model.Content.GivenRelationExplanation" />
          <div class="medium-6">
            <button
              @click="redirectToCreatePage"
              class="button large"
              :disabled="!vueModel.CanUsePowerOfAttorneyFunctionality"
              data-clickcategory="minside"
              data-clickaction="click-fs mine fuldmagter"
              data-clicklabel="tilføj fuldmagt"
            >
              <span v-html="model.Content.GivenAddPOAButtonText" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <transition name="modal">
      <v-modal :is-open="showModalFail" @close="showModalFail = false">
        <template #title>
          <h3>Uventet fejl</h3>
        </template>
        <template #content>
          <div>
            <p>
              Der skete en uventet fejl. Prøv igen senere eller kontakt os.
              <a class="text-large" href="tel:+4533117755">Ring 33 11 77 55</a>
            </p>
            <a @click="showModalFail = false" class="button large close-modal">Luk</a>
          </div>
        </template>
        <template #footer>
          <div />
        </template>
      </v-modal>
    </transition>
    <poa-modal
      :contact-id="contactId"
      :redirect-to="redirectTo"
      @reset="reset"
      :redirect-messages="{
        LB: model.Content.LabelTextModalConfirmRedirectToOtherBrandLB,
        Runa: model.Content.LabelTextModalConfirmRedirectToOtherBrandRuna,
        Bauta: model.Content.LabelTextModalConfirmRedirectToOtherBrandBauta,
        PFA: model.Content.LabelTextModalConfirmRedirectToOtherBrandPFA
      }"
      :label-no="model.Content.LabelCancelRedirect"
      :label-redirect="model.Content.LabelConfirmRedirect"
    />
  </section>

  <section id="tcb" v-if="!model">
    <div class="container">
      <div class="row large-unstack">
        <div class="columns">
          <h1>Mine fuldmagter</h1>
          <div class="padding-bottom" />
        </div>
        <div class="columns block--right" />
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import BaseMixin from '@/components/Feature/BaseMixin.vue';

import PoaModal from './components/PowerOfAttorneyModal.vue';

export default {
  name: 'PowerOfAttorney',
  components: {
    'poa-modal': PoaModal
  },
  mixins: [BaseMixin],
  props: {
    model: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      pending: false,
      showModalFail: false,
      redirectTo: null,
      contactId: null
    };
  },
  computed: {
    vueModel() {
      return this.model.Data;
    },
    modalTexts() {
      return {
        LB: this.model.Content.LabelTextModalConfirmRedirectToOtherBrandLB,
        Runa: this.model.Content.LabelTextModalConfirmRedirectToOtherBrandRuna,
        Bauta: this.model.Content.LabelTextModalConfirmRedirectToOtherBrandBauta,
        PFA: this.model.Content.LabelTextModalConfirmRedirectToOtherBrandPFA
      };
    }
  },
  mounted() {
    // TODO: feature toggle hack, should probably be removed
    if (this.vueModel === undefined) {
      return;
    }

    for (const prop in this.vueModel.PowersOfAttorneyReceivedFrom) {
      this.vueModel.PowersOfAttorneyReceivedFrom[prop].pendingGiver = false;
    }
  },
  methods: {
    switchToMember(giver, url) {
      this.pending = true;
      giver.pendingGiver = true;
      const self = this;
      axios
        .post(`/api/impersonation/setgiver/${giver.ContactId}`)
        .then((response) => {
          this.pending = false;
          giver.pendingGiver = false;
          window.onbeforeunload = function () {
            $('body').fadeOut();
            // window.scrollTo(0, 0);
            self.scrollToTop();
          };
          if (response.data.includes('POABrandDosntMatchWithCurrentRedirectTo')) {
            this.contactId = giver.ContactId;
            this.redirectTo = response.data.replace('POABrandDosntMatchWithCurrentRedirectTo', '');
          } else if (response !== 'approved') {
            window.location.assign(url);
          } else {
            this.showModalFail = true;
          }
        })
        .catch(() => {
          this.pending = false;
          giver.pendingGiver = false;
          this.showModalFail = true;
        });
    },
    redirectToCreatePage() {
      window.location = this.vueModel.PowerOfAttorneyAddUrl;
    },
    redirectToEditPage(id) {
      window.location = `${this.vueModel.PowerOfAttorneyEditUrl}?memberId=${id}`;
    },
    reset() {
      this.contactId = null;
      this.redirectTo = null;
    }
  }
};
</script>
